<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('progressReports.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [multiSelectClassrooms]="false"
    [multiSelectSites]="false"
    [showLocale]="true"
    [showStudentSelect]="true"
    [onlyLocked]="true"
    [canSelectAll]="true"
    (showReportClicked)="showReport($event)"
    (downloadReportClicked)="downloadReport($event)"
    [requiredFields]="requiredFields"
    [is2025]="is2025"
  (clearClicked)="handleClear()"></drdp-report-search>
  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }
</div>
</ng-container>
